import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  HostListener,
} from "@angular/core";
import { AppService } from "../services/app.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { SupportService } from "../services/support-service";
import { Router } from "@angular/router";

@Component({
  selector: "app-insurance",
  templateUrl: "./insurance.component.html",
  styleUrls: ["./insurance.component.scss"],
})
export class InsuranceComponent implements OnInit {
  insuranceList: any;
  saveInsuranceList: any;
  tcInsuranceList: any;
  selectedInsurance: any;
  otherIns: any;
  available = false;
  disabled = true;
  ins: any = "";
  CountryId: any;
  generalvalidationMessage: any;
  selected1 = false;
  selected2 = false;
  selected3 = false;
  ngxsearch = "";
  selectedlang: any = [];
  selected = false;
  selectedType: any;
  selectedObject: any = [];
  errorMessage: string;
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  Message: any = "";
  insuranceSubmit = false;
  insuranceBoolean = false;

  saveinsuranceList = [];
  updateobj = false;
  z;
  i = 0;
  alert: any;
  popuptype: any = "";

  @ViewChild("generalvalidation") generalvalidation: TemplateRef<any>;
  @ViewChild("deletePopup") deletePopup: TemplateRef<any>;
  constructor(
    private appservice: AppService,
    private modalService: BsModalService,
    private supportService: SupportService,
    private router: Router
  ) {
    this.insuranceList = [];
    this.tcInsuranceList = [];
  }

  @HostListener("window:scroll", ["$event"]) scrollHandler() {}
  ngOnInit() {
    this.selectedInsurance = [
      {
        insuranceName: "",
        tempInsurance: "",
        selected1: false,
        selected2: false,
        selected3: false,
        selected: false,
      },
    ];
    sessionStorage.setItem("type", "insurance");
    if (localStorage.getItem("countryId") != null) {
      this.CountryId = localStorage.getItem("countryId");
      if (this.CountryId === "101") {
        this.selectedType = 1;
        this.selected = true;
      }
      const data = {
        countryId: localStorage.getItem("countryId"),
      };
      this.getallinsurancebycountry(data);
    } else {
      this.getCurrentIPAddress();
    }

    this.getLanguage();
    this.viewTCinsurance();
    if (localStorage.getItem("testCenterName") != null) {
      this.supportService.testCenterName.next(
        localStorage.getItem("testCenterName")
      );
    }

    if (localStorage.getItem("stateName") != null) {
      this.supportService.stateName.next(localStorage.getItem("stateName"));
    }
  }

  clearmessage() {
    setTimeout(() => {
      this.errorMessage = "";
      this.Message = "";
    }, 5000);
  }

  checkinsurance(value, i) {
    if (value) {
      for (let index = 0; index < this.selectedInsurance.length; index++) {
        if (
          this.selectedInsurance[index].insuranceName
            .toString()
            .toLowerCase() === value.toString().toLowerCase()
        ) {
          this.Message = "";
          this.errorMessage = "Insurance already exists";
          this.clearmessage();
          return;
        } else {
          this.selectedInsurance[index].insuranceName = this.selectedInsurance[
            index
          ].tempInsurance;
        }
      }
    } else {
      this.selectedInsurance[i].insuranceName = "";
    }
  }

  addInsurance() {
    for (let index = 0; index < this.selectedInsurance.length; index++) {
      if (this.CountryId === "231") {
        if (
          !this.selectedInsurance[index].insuranceName ||
          !this.selectedInsurance[index].selected
        ) {
          this.Message = "";
          this.errorMessage = "Please fill missing info";
          this.clearmessage();
          this.insuranceSubmit = true;
          return;
        }
      } else {
        if (!this.selectedInsurance[index].insuranceName) {
          this.Message = "";
          this.errorMessage = "Please fill Insurance";
          this.clearmessage();
          this.insuranceSubmit = true;
          return;
        }
      }
    }

    this.insuranceSubmit = false;

    this.selectedInsurance.push({
      insuranceName: "",
      tempInsurance: "",
      selected1: false,
      selected2: false,
      selected3: false,
      selected: false,
    });
  }

  getCurrentIPAddress() {
    this.appservice.getCurrentIPAddress().subscribe((res) => {
      if (res && res["ip"]) {
        this.getAddressBasedonCurrentIp(res["ip"]);
      }
    });
  }

  getAddressBasedonCurrentIp(ip) {
    this.appservice.getAddressBasedonCurrentIp(ip).subscribe((res) => {
      let data = {};
      if (res && res["status"] === "success") {
        if (res["countryCode"] === "IN") {
          data = {
            countryId: localStorage.getItem("101"),
          };
        } else if (res["countryCode"] === "US") {
          data = {
            countryId: localStorage.getItem("231"),
          };
        }
        this.getallinsurancebycountry(data);
      }
    });
  }

  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res && res["commonMsg"]) {
        this.selectedlang = res["commonMsg"];
      }
    });
  }

  changed(value, type, i) {
    if (type === "both") {
      this.selectedInsurance[i].selected1 = true;
      this.selectedInsurance[i].selected2 = false;
      this.selectedInsurance[i].selected3 = false;
      this.selectedInsurance[i].selectedType = 1;
    }
    if (type === "hmo") {
      this.selectedInsurance[i].selected1 = false;
      this.selectedInsurance[i].selected2 = true;
      this.selectedInsurance[i].selected3 = false;
      this.selectedInsurance[i].selectedType = 2;
    }
    if (type === "ppo") {
      this.selectedInsurance[i].selected1 = false;
      this.selectedInsurance[i].selected2 = false;
      this.selectedInsurance[i].selected3 = true;
      this.selectedInsurance[i].selectedType = 3;
    }
    this.selectedInsurance[i].selected = true;
  }

  changingInsurance(value) {
    if (value) {
      this.selectedObject = [];
      this.available = false;
      for (let index = 0; index < this.insuranceList.length; index++) {
        const listName = this.insuranceList[index].name;
        if (listName) {
          if (
            listName.toString().toLowerCase() === value.toString().toLowerCase()
          ) {
            this.selectedObject = this.insuranceList[index];
            this.available = true;
            break;
          }
        }
      }

      if (!this.available) {
        this.otherIns = value;
      }
    }
  }

  reset() {
    this.insuranceSubmit = false;
    this.selected = false;
    if (localStorage.getItem("countryId") != null) {
      this.CountryId = localStorage.getItem("countryId");
      if (this.CountryId === "101") {
        this.selectedType = 1;
        this.selected = true;
      }
    }
    this.selectedObject = [];
    this.selected1 = false;
    this.selected2 = false;
    this.selected3 = false;
    this.otherIns = "";
    this.available = false;
    this.selectedInsurance = [];
  }
  public inputTyped = (source: string, text: string) =>
    console.log("SingleDemoComponent.inputTyped", source, text);

  public doSelectOptions(options) {
    if (options && options.length > 0) {
      this.ngxsearch = "";
    }
  }

  getallinsurancebycountry(data) {
    this.appservice.getallinsurancebycountry(data).subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"]["status"] &&
          res["status"]["status"] === 200
        ) {
          this.insuranceList = res["entity"];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  viewTCinsurance() {
    const data = {
      testcenterid: localStorage.getItem("testCenterId"),
    };

    this.appservice.viewTCinsurance(data).subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"]["status"] &&
          res["status"]["status"] === 200
        ) {
          this.tcInsuranceList = res["entity"];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  closepopup() {
    this.viewTCinsurance();
    this.modalRef.hide();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  saveInsurance() {
    this.insuranceSubmit = true;
    this.saveinsuranceList = [];
    if (!this.insuranceBoolean) {
      this.insuranceBoolean = true;
      if (this.selectedInsurance.length > 0) {
        for (let index = 0; index < this.selectedInsurance.length; index++) {
          if (this.selectedInsurance[index].insuranceName) {
            var p = 0;
            for (let i = 0; i < this.insuranceList.length; i++) {
              if (
                this.insuranceList[i].name.toString().toLowerCase() ===
                this.selectedInsurance[index].insuranceName
                  .toString()
                  .toLowerCase()
              ) {
                p = 1;
                this.selectedObject = this.insuranceList[i];
                this.saveinsuranceList.push({
                  insuranceId: this.selectedObject.id,
                  insuranceName: this.selectedObject.name,
                  insuranceTypeId: this.selectedObject.countryId === 231?this.selectedInsurance[index].selectedType:1,
                  countryId: this.selectedObject.countryId,
                });
                break;
              }

              if (i + 1 === this.insuranceList.length && p === 0) {
                this.saveinsuranceList.push({
                  insuranceId: "",
                  insuranceName: this.selectedInsurance[index].insuranceName,
                  insuranceTypeId: this.CountryId === 231?this.selectedInsurance[index].selectedType:1,
                  countryId: this.CountryId,
                });
              }
            }
          } else {
            this.Message = "";
            this.errorMessage = "Please Fill insurance name";
            this.clearmessage();
            this.insuranceBoolean = false;
            return;
          }
          if (index + 1 === this.selectedInsurance.length) {
            this.errorMessage=''
            this.appservice
              .addorupdateTCinsurance({
                insuranceInput: this.saveinsuranceList,
              })
              .subscribe(
                (res) => {
                  if (res && res["status"] && res["status"]["status"] === 200) {
                    this.Message = this.selectedlang.insSuccessfully;
                    this.reset();
                    setTimeout(() => {
                      this.Message = "";
                    }, 5000);

                    if (
                      localStorage.getItem("subscriptionflag") !== null &&
                      localStorage.getItem("subscriptionflag") === "false"
                    ) {
                      setTimeout(() => {
                        this.router.navigate([
                          localStorage.getItem("testCode").toString().trim(),
                          "profile-photos",
                        ]);
                      }, 1500);
                    } else {
                      this.addInsurance();
                      const data = {
                        countryId: localStorage.getItem("countryId"),
                      };
                      this.getallinsurancebycountry(data);
                      this.viewTCinsurance();
                    }
                  }else{
                    this.errorMessage = "Please Fill insurance type";
                  }
                  this.insuranceBoolean = false;
                },
                (err) => {
                  this.appservice.sessionOut(err);
                  this.insuranceBoolean = false;
                }
              );
          }
        }
      }
    }
  }

  editInsuranceType() {
    this.updateobj = false;
    const data = {
      insuranceInput: [
        {
          insuranceId: this.tcInsuranceList[this.i].insurance.id,
          insuranceName: this.tcInsuranceList[this.i].insurance.name,
          insuranceTypeId: this.tcInsuranceList[this.i].type,
          countryId: this.tcInsuranceList[this.i].insurance.countryId,
        },
      ],
    };
    this.appservice.addorupdateTCinsurance(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          this.Message = this.selectedlang.insUpdate;
          setTimeout(() => {
            this.Message = "";
          }, 5000);
        }
        this.viewTCinsurance();
      },

      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  changeInsuranceType(type, i) {
    this.updateobj = true;
    this.tcInsuranceList[i].type = type;
    this.confirmEdit(i);
  }

  removebeforesaveins(index) {
    this.tcInsuranceList.splice(index, 1);
  }
  removeInsurance(index) {
    const removed_element = this.tcInsuranceList[index].id;
    if (removed_element != null) {
      this.appservice.deleteTCinsurance(removed_element).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.tcInsuranceList.splice(index, 1);
            this.Message = this.selectedlang.insDeleted;
          }
          if (res && res["status"] && res["status"]["status"] === 204) {
            this.Message = "";
            this.errorMessage = this.selectedlang.norec;
          }
          if (res && res["status"] && res["status"]["status"] === 230) {
            this.Message = "";
            this.errorMessage = this.selectedlang.dataRequired;
          }
          setTimeout(() => {
            this.Message = "";
          }, 5000);
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  deletedchoosedinsurance(index) {
    this.selectedInsurance.splice(index, 1);
  }

  confirmationPopAfterSave(i) {
    this.i = i;
    this.popuptype = "Delete";
    this.alert = "Remove";
    this.generalvalidationMessage = this.selectedlang.popupIns;
    this.openModal(this.deletePopup);
  }
  ConfirmReset() {
    this.popuptype = "Reset";
    this.alert = this.selectedlang.reset;
    this.generalvalidationMessage = this.selectedlang.popupReset;
    this.openModal(this.deletePopup);
  }

  confirmEdit(i) {
    if (this.updateobj) {
      this.i = i;
      this.popuptype = "Edit";
      this.alert = "Info";
      this.generalvalidationMessage = this.selectedlang.popupEdit;
      this.openModal(this.deletePopup);
    } else {
      this.alert = this.selectedlang.info;
      this.generalvalidationMessage = this.selectedlang.noChange;
      this.openModal(this.generalvalidation);
    }
  }

  triggerPopup() {
    if (this.popuptype === "Delete") {
      this.removeInsurance(this.i);
    }
    if (this.popuptype === "Edit") {
      this.editInsuranceType();
    }
    if (this.popuptype === "Reset") {
      this.reset();
    }

    document.getElementById("closepopup").click();
  }
}
